var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"min-h-screen w-screen supports-[height:100dvh]:min-h-dvh"},[_c('Nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }